import '@styles/RecommendedIcon/style.css'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Icon from '../Icons'
import { RECOMMENDED_ICON } from '../resources'
import Typography from '../Typography'

const SmallRecommendedIcon: React.FC = (): JSX.Element => {
  const { t } = useTranslation()
  return (
    <div className={'recommended'}>
      <Typography variant={'body2'} classes={'recommended-text'}>
        {t('common.label.reco', 'Reco')}
      </Typography>
      <Icon imageSrc={RECOMMENDED_ICON} alt={'recommended'} />
    </div>
  )
}

export default SmallRecommendedIcon
